import type { RawParams } from "@uirouter/core";

import type { SubscriptionParams } from "app/pages/sales-intelligence/types/subscriptions";

export const getSubscriptionParams = (routeParams: RawParams): SubscriptionParams => {
    const { subscriptionCancelType, digestAssetId, digestAssetType } = routeParams;

    return { subscriptionCancelType, digestAssetId, digestAssetType };
};
